/**
 *
 * @module subscriptionType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionType
 * @type {Object}
 *
 * @property {String} BAM_IDENTITY
 * @property {String} BEARER
 * @property {String} EXTERNAL_IDENTITY
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access private
     * @type {String}
     *
     */
    BAM_IDENTITY: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    BEARER: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    EXTERNAL_IDENTITY: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionType.js